import { cultureCheck } from '@/utils/cultureCheck'

const fieldKeys = {
  account_nl_NL: [
    ['FirstName', 'MiddleName', 'LastName'],
    ['CountryCode'],
    ['PostalCode', 'HouseNumber', 'HouseNumberExtension'],
    ['StreetName', 'City'],
    ['PhoneNumber', 'EMailAddress']
  ],
  passengerAddressRequiredFields_nl_NL: [
    ['FirstName', 'MiddleName', 'LastName'],
    ['BirthDate', 'BirthPlace'],
    ['PostalCode', 'HouseNumber', 'HouseNumberExtension'],
    ['StreetName', 'City'],
    ['CountryCode'],
    ['EMailAddress']
  ],
  allPassengerFields_nl_NL: [
    'FirstName',
    'MiddleName',
    'LastName',
    'BirthDate',
    'BirthPlace',
    'CountryCode',
    'PostalCode',
    'HouseNumber',
    'HouseNumberExtension',
    'StreetName',
    'City',
    'LegalRepresentativeLink1',
    'LegalRepresentativeLink2',
    'EMailAddress'
  ],
  soloPassenger_nl_NL: [
    ['FirstName', 'MiddleName', 'LastName'],
    ['BirthDate', 'BirthPlace'],
    ['City', 'EMailAddress']
  ],
  extraPassenger_nl_NL: [
    ['FirstName', 'MiddleName', 'LastName'],
    ['BirthDate', 'BirthPlace'],
    ['City', 'EMailAddress']
  ],
  extraMinorPassenger_nl_NL: [
    ['FirstName', 'MiddleName', 'LastName'],
    ['BirthDate', 'BirthPlace'],
    ['CountryCode', ''],
    ['PostalCode', 'HouseNumber', 'HouseNumberExtension']
  ],
  extraMinorWithAddress_nl_NL: [
    ['FirstName', 'MiddleName', 'LastName'],
    ['BirthDate', 'BirthPlace'],
    ['CountryCode', ''],
    ['PostalCode', 'HouseNumber', 'HouseNumberExtension'],
    ['StreetName', 'City']
  ],
  minorPassenger_nl_NL: [
    ['FirstName', 'MiddleName', 'LastName'],
    ['BirthDate', 'BirthPlace'],
    ['CountryCode', ''],
    ['PostalCode', 'HouseNumber', 'HouseNumberExtension'],
    ['StreetName', 'City'],
    'LegalRepresentativeLink1',
    'LegalRepresentativeLink2'
  ],
  nonPassenger_nl_NL: [
    ['FirstName', 'MiddleName', 'LastName'],
    ['BirthDate', 'BirthPlace'],
    ['CountryCode', ''],
    ['PostalCode', 'HouseNumber', 'HouseNumberExtension'],
    ['EMailAddress', '']
  ],
  nonPassengerWithAddress_nl_NL: [
    ['FirstName', 'MiddleName', 'LastName'],
    ['BirthDate', 'BirthPlace'],
    ['CountryCode', ''],
    ['PostalCode', 'HouseNumber', 'HouseNumberExtension'],
    ['StreetName', 'City'],
    ['EMailAddress', '']
  ],
  requiredFields_nl_NL: [
    'FirstName',
    'LastName',
    'BirthDate',
    'BirthPlace',
    'CountryCode',
    'PostalCode',
    'HouseNumber',
    'LegalRepresentativeLink1',
    'LegalRepresentativeLink2',
    'EMailAddress'
  ],
  account_de_DE: [
    ['FirstName', 'LastName'],
    ['CountryCode'],
    ['PostalCode', 'HouseNumber', 'HouseNumberExtension'],
    ['StreetName', 'City'],
    ['PhoneNumber', 'EMailAddress']
  ],
  passengerAddressRequiredFields_de_DE: [
    ['FirstName', 'MiddleName', 'LastName'],
    ['BirthDate', 'BirthPlace'],
    ['PostalCode', 'HouseNumber', 'HouseNumberExtension'],
    ['StreetName', 'City'],
    ['CountryCode'],
    ['EMailAddress']
  ],
  allPassengerFields_de_DE: [
    'FirstName',
    'LastName',
    'BirthDate',
    'BirthPlace',
    'CountryCode',
    'PostalCode',
    'HouseNumber',
    'HouseNumberExtension',
    'StreetName',
    'City',
    'LegalRepresentativeLink1',
    'LegalRepresentativeLink2',
    'EMailAddress'
  ],
  soloPassenger_de_DE: [
    ['FirstName', 'LastName'],
    ['BirthDate', 'BirthPlace'],
    ['City', 'EMailAddress']
  ],
  extraPassenger_de_DE: [
    ['FirstName', 'LastName'],
    ['BirthDate', 'BirthPlace'],
    ['City', 'EMailAddress']
  ],
  extraMinorPassenger_de_DE: [
    ['FirstName', 'LastName'],
    ['BirthDate', 'BirthPlace'],
    ['CountryCode', ''],
    ['PostalCode', 'HouseNumber', 'HouseNumberExtension']
  ],
  extraMinorWithAddress_de_DE: [
    ['FirstName', 'LastName'],
    ['BirthDate', 'BirthPlace'],
    ['CountryCode', ''],
    ['PostalCode', 'HouseNumber', 'HouseNumberExtension'],
    ['StreetName', 'City']
  ],
  minorPassenger_de_DE: [
    ['FirstName', 'LastName'],
    ['BirthDate', 'BirthPlace'],
    ['CountryCode', ''],
    ['PostalCode', 'HouseNumber', 'HouseNumberExtension'],
    ['StreetName', 'City'],
    'LegalRepresentativeLink1',
    'LegalRepresentativeLink2'
  ],
  nonPassenger_de_DE: [
    ['FirstName', 'LastName'],
    ['BirthDate', 'BirthPlace'],
    ['CountryCode', ''],
    ['PostalCode', 'HouseNumber', 'HouseNumberExtension'],
    ['EMailAddress', '']
  ],
  nonPassengerWithAddress_de_DE: [
    ['FirstName', 'LastName'],
    ['BirthDate', 'BirthPlace'],
    ['CountryCode', ''],
    ['PostalCode', 'HouseNumber', 'HouseNumberExtension'],
    ['StreetName', 'City'],
    ['EMailAddress', '']
  ],
  requiredFields_de_DE: [
    'FirstName',
    'LastName',
    'BirthDate',
    'BirthPlace',
    'CountryCode',
    'PostalCode',
    'HouseNumber',
    'LegalRepresentativeLink1',
    'LegalRepresentativeLink2',
    'EMailAddress'
  ],
  account_en_GB: [
    ['FirstName', 'LastName'],
    ['CountryCode'],
    ['PostalCode', 'HouseNumber', 'HouseNumberExtension'],
    ['StreetName', 'City'],
    ['PhoneNumber', 'EMailAddress']
  ],
  passengerAddressRequiredFields_en_GB: [
    ['FirstName', 'MiddleName', 'LastName'],
    ['BirthDate', 'BirthPlace'],
    ['PostalCode', 'HouseNumber', 'HouseNumberExtension'],
    ['StreetName', 'City'],
    ['CountryCode'],
    ['EMailAddress']
  ],
  allPassengerFields_en_GB: [
    'FirstName',
    'LastName',
    'BirthDate',
    'BirthPlace',
    'CountryCode',
    'PostalCode',
    'HouseNumber',
    'HouseNumberExtension',
    'StreetName',
    'City',
    'LegalRepresentativeLink1',
    'LegalRepresentativeLink2',
    'EMailAddress'
  ],
  soloPassenger_en_GB: [
    ['FirstName', 'LastName'],
    ['BirthDate', 'BirthPlace'],
    ['City', 'EMailAddress']
  ],
  extraPassenger_en_GB: [
    ['FirstName', 'LastName'],
    ['BirthDate', 'BirthPlace'],
    ['City', 'EMailAddress']
  ],
  extraMinorPassenger_en_GB: [
    ['FirstName', 'LastName'],
    ['BirthDate', 'BirthPlace'],
    ['CountryCode', ''],
    ['PostalCode', 'HouseNumber', 'HouseNumberExtension']
  ],
  extraMinorWithAddress_en_GB: [
    ['FirstName', 'LastName'],
    ['BirthDate', 'BirthPlace'],
    ['CountryCode', ''],
    ['PostalCode', 'HouseNumber', 'HouseNumberExtension'],
    ['StreetName', 'City']
  ],
  minorPassenger_en_GB: [
    ['FirstName', 'LastName'],
    ['BirthDate', 'BirthPlace'],
    ['CountryCode', ''],
    ['PostalCode', 'HouseNumber', 'HouseNumberExtension'],
    ['StreetName', 'City'],
    'LegalRepresentativeLink1',
    'LegalRepresentativeLink2'
  ],
  nonPassenger_en_GB: [
    ['FirstName', 'LastName'],
    ['BirthDate', 'BirthPlace'],
    ['CountryCode', ''],
    ['PostalCode', 'HouseNumber', 'HouseNumberExtension'],
    ['EMailAddress', '']
  ],
  nonPassengerWithAddress_en_GB: [
    ['FirstName', 'LastName'],
    ['BirthDate', 'BirthPlace'],
    ['CountryCode', ''],
    ['PostalCode', 'HouseNumber', 'HouseNumberExtension'],
    ['StreetName', 'City'],
    ['EMailAddress', '']
  ],
  requiredFields_en_GB: [
    'FirstName',
    'LastName',
    'BirthDate',
    'BirthPlace',
    'CountryCode',
    'PostalCode',
    'HouseNumber',
    'LegalRepresentativeLink1',
    'LegalRepresentativeLink2',
    'EMailAddress'
  ]
}

const splitIntoColumns = function (sourceArray) {
  const result = []
  let start = 0
  if (sourceArray.length % 2 !== 0) {
    result.push([sourceArray[0]])
    start = 1
  }
  for (let cell = start; cell < sourceArray.length; cell += 2) {
    result.push([sourceArray[cell], sourceArray[cell + 1]])
  }
  return result
}

const getFieldKeys = function (keyName) {
  keyName += '_' + cultureCheck().replace('-', '_')
  if (Object.prototype.hasOwnProperty.call(fieldKeys, keyName)) {
    return fieldKeys[keyName]
  }
  return []
}

export {
  getFieldKeys,
  splitIntoColumns
}
